import { Link } from 'gatsby'
import { useMobile } from 'src/hooks/useMobile'

import './style.scss'
import { CallToAction } from '../../campaign/common/CallToAction'

export default function DoubleBannerPromotion({
  title: titleSection,
  banners,
  fontColor,
  backgroundColor,
}: any) {
  const [mainBanner, secondaryBanner] = banners
  const { screenWidth } = useMobile()

  function renderImage(images: any) {
    if (screenWidth > 1020) {
      return images?.desktop
    }

    if (screenWidth > 680 && screenWidth < 1020) {
      return images?.tablet
    }

    return images?.mobile
  }

  return (
    <section className="sectionPromotion" style={{ backgroundColor }}>
      <section className="containerPromotion">
        <h3 className="titleSectionPromotion" style={{ color: fontColor }}>
          {titleSection}
        </h3>
        <section className="containerBanners">
          {[mainBanner, secondaryBanner].map((banner, index) => {
            const title = banner?.title
            const text = banner?.text
            const priceContainer = banner?.priceContainer
            const cta = banner?.cta
            const linkURL = banner?.linkURL
            const images = banner?.images

            return (
              <div
                key={index}
                className="flex flex-col containerBanner firstBanner md:pr-4"
              >
                <Link
                  style={{ backgroundImage: `url(${renderImage(images)})` }}
                  to={linkURL || '#'}
                  className="bannerPromotionItem mainBanner"
                >
                  <h2 style={{ color: title?.fontColor ?? '#000' }}>
                    {title?.text}
                  </h2>
                  <h4 style={{ color: text?.fontColor ?? '#000' }}>
                    {text?.body}
                  </h4>
                  {priceContainer?.enable && priceContainer ? (
                    <div className="ctaPromotion">
                      <p style={{ color: priceContainer?.fontColor ?? '#000' }}>
                        {priceContainer?.subtitlePrice}
                      </p>
                      <h5
                        style={{ color: priceContainer?.fontColor ?? '#000' }}
                      >
                        {priceContainer?.price}
                      </h5>
                    </div>
                  ) : (
                    <div />
                  )}
                  {cta?.enable && cta ? (
                    <CallToAction
                      link={linkURL}
                      text={cta?.text}
                      fontColor={cta?.fontColor}
                      backgroundColor={cta?.backgroundColor}
                      hover="#F7F8F9"
                    />
                  ) : (
                    <div />
                  )}
                </Link>
              </div>
            )
          })}
        </section>
      </section>
    </section>
  )
}
